import React, { useRef, useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import MediaPreview from 'src/js/modules/common/components/media-preview';

function GalleryIframePreview({ src }) {
  const mediaPreviewRef = useRef(null);
  const [scaledWidth, setScaledWidth] = useState(null);
  const [displayWidth, setDisplayWidth] = useState(null);

  useLayoutEffect(() => {
    if (mediaPreviewRef.current) {
      const width = mediaPreviewRef.current.offsetWidth;

      setDisplayWidth(width);
      setScaledWidth(width / 0.5);
    }
  }, []);

  return (
    <div className="ws-gallery-iframe-preview">
      <div className="ws-gallery-iframe-preview__background-box">
        <MediaPreview
          ref={mediaPreviewRef}
          type="iframe"
          url={src}
          placeholderType="code"
          placeholderTitle={i18next.t('Preview is not available')}
          scaledWidth={scaledWidth}
          displayWidth={displayWidth}
        />
      </div>
    </div>
  );
}

GalleryIframePreview.propTypes = {
  src: PropTypes.string.isRequired,
};

export default GalleryIframePreview;
